import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { alert } from './alert.reducer';
import { logintype } from './logintype.reducer';
import { reducer as formReducer } from 'redux-form'

const rootReducer = combineReducers({
  authentication,
  alert,
  logintype,
  form: formReducer
});

export default rootReducer;